import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "h-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_form = _resolveComponent("create-form")!
  const _component_assign_modal_form = _resolveComponent("assign-modal-form")!
  const _component_loader = _resolveComponent("loader")!
  const _component_table_action_header = _resolveComponent("table-action-header")!
  const _component_custom_table = _resolveComponent("custom-table")!
  const _component_main_section = _resolveComponent("main-section")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isCreateModalOpened)
      ? (_openBlock(), _createBlock(_component_create_form, {
          key: 0,
          "is-create-modal-opened": _ctx.isCreateModalOpened,
          "refresh-data": _ctx.getICDData,
          icdData: _ctx.Icds,
          onToggleModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCreateModalOpened = false)),
          onNewMacCreated: _ctx.refreshNewMacCreated
        }, null, 8, ["is-create-modal-opened", "refresh-data", "icdData", "onNewMacCreated"]))
      : _createCommentVNode("", true),
    (_ctx.isAssignModalOpened)
      ? (_openBlock(), _createBlock(_component_assign_modal_form, {
          key: 1,
          "is-assign-icd-modal-opened": _ctx.isAssignModalOpened,
          "sensor-mac": _ctx.selectedICDData.mac,
          onToggleModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isAssignModalOpened = false)),
          onRefreshIcdReport: _ctx.getICDData
        }, null, 8, ["is-assign-icd-modal-opened", "sensor-mac", "onRefreshIcdReport"]))
      : _createCommentVNode("", true),
    _createVNode(_component_main_section, null, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_table_action_header, {
                icon: ['fas', 'add'],
                "permission-id": _ctx.permissions.CreateAssignment,
                title: _ctx.$t('ICDManagement.Title'),
                "button-text": _ctx.$t('ICDManagement.Assign'),
                onExecuteMethod: _ctx.toggleCreateModal
              }, null, 8, ["permission-id", "title", "button-text", "onExecuteMethod"]),
              _createVNode(_component_custom_table, {
                "is-action-list-not-displayed": true,
                "is-data-source-loading": _ctx.isDataSourceLoading,
                "show-per-page": 16,
                "table-data": _ctx.Icds,
                "table-headers": _ctx.tableHeadersICD,
                "allow-updating-prop": true,
                "table-height": "93%",
                onForceRefresh: _ctx.getICDData,
                onSelectedRows: _ctx.getSelectedRows,
                onUnassignIcdTag: _ctx.onUnassign,
                onEditIcdTagName: _ctx.editIcdTagName,
                onAssignIcdTag: _ctx.toggleAssignIcdModal
              }, null, 8, ["is-data-source-loading", "table-data", "table-headers", "onForceRefresh", "onSelectedRows", "onUnassignIcdTag", "onEditIcdTagName", "onAssignIcdTag"])
            ]))
      ]),
      _: 1
    })
  ], 64))
}